import React from 'react'
import styled from 'styled-components'
import ButtonComponent from '../components/ButtonComponent'
import ContentArea from '../components/ContentArea'



const StressReliefPage = ({ match }) => {
    return (
        <ContentArea home transparent shadowless fullsize>
          <ButtonComponent text="Mindfulness" link="/meditate" />
          <ButtonComponent text="Relaxation" link="/relaxation" />
          <ButtonComponent text="Mindful Movement" link="/yoga" />
          <ButtonComponent text="Guided Imagery" link="/imagery" />
          
        </ContentArea >
      )
}

export default StressReliefPage
